import icon from "images/icons/icon-private.svg"

export default function PrivateIcon() {
  return (
    <span className="svg-icon" dangerouslySetInnerHTML={{ __html: icon }} />
  )
}
